import { OkpoModel } from '../../organizationsStore/organizationsStoreData';
import AbstractNsiStoreService from '../abstractNsiStore.service';

export class NsiOkpoStoreService extends AbstractNsiStoreService<OkpoModel> {
  path = 'okpo';
}
